import { render, staticRenderFns } from "./img-compress-mobile.vue?vue&type=template&id=7edb55ef&scoped=true&"
import script from "./img-compress-mobile.vue?vue&type=script&lang=js&"
export * from "./img-compress-mobile.vue?vue&type=script&lang=js&"
import style0 from "./img-compress-mobile.vue?vue&type=style&index=0&id=7edb55ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb55ef",
  null
  
)

export default component.exports